module.exports = __webpack_public_path__ + "static/US1_1P modern-3b26bdcbb3514ff964a0fe454d7b48a2.png";